/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InjuryType {
    PHYSICAL = 'Physical',
    MENTAL = 'Mental',
}
